module.exports = __webpack_public_path__ + "static/media/conheca-joinville4.ee964fa0.webp";